import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC_YReBC6t1SIlNKYeOfku1wz3UZtN0HKQ",
  authDomain: "sayeret-1aba9.firebaseapp.com",
  projectId: "sayeret-1aba9",
  storageBucket: "sayeret-1aba9.appspot.com",
  messagingSenderId: "174418544154",
  appId: "1:174418544154:web:4730f6b569cc3d916833a3",
};
// Initialize Firebase
export const firebaseapp = firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();
export const storage = firebase.storage();
